<app-header [translation]="myLanguage"></app-header>

<div class="container">
    <a routerLink="/">{{ myLanguage.back }}</a>

    <div class="alert alert-danger mt-2 mb-2" *ngIf="error !== ''">{{error}}</div>

    <article class="mt-4" *ngIf="faq !== undefined">
        <h1 class="post-title" style="margin-top: 0">{{ faq.question }}</h1>
        <div class="post-body" [innerHTML]="safeHTML(faq.answer)"></div>
    </article>
</div>

<app-footer [translation]="myLanguage" [userData]="userData"></app-footer>